import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import FeatureSection from "../components/FeatureSection";
// import PricingSection from "../components/PricingSection";
import ContactSection from "../components/ContactSection";

function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <FeatureSection />
      {/* <PricingSection /> */}
      <ContactSection />
    </>
  );
}

export default Home;
